<template>
    <div class="sup-func-list">
        <div class="re-w1200 re-main-col">
            <div class="top-box">
                <span class="top-title">为泛工程领域可视化专业需求量身打造</span>
                <div class="dis-box">
                    <span class="top-dis">测量、剖切、漫游、锚点、标签、标注、二三维联动、小地图、在线编辑等更多功能供您选择</span>
                </div>
            </div>
            <div class="grid-list-box">
                <div class="grid-item-box" v-for="(item, index) in function_list" :key="`item_${index}`" @click="func_grid_item_click(item)">
                    <re-img
                        class="grid-item-img"
                        :src="downloadBaseUrl_computed(item.coverImgPath)"
                        :ph="require(`@/assets/imgs/product/placeholder_bg.png`)"></re-img>
                    <div class="gird-item-title-box">
                        <span>{{ item.coverTitle }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import { useRouterStore } from '@/stores/router';
import { getEngineFunctionList } from '@/service/interface';

const router_store = useRouterStore();
const { proxy } = getCurrentInstance();

const function_list = ref([]); //功能列表

const downloadBaseUrl_computed = computed(() => (path) => {
    let url = '';
    if (path && path.length) {
        url = `${window.downloadBaseUrl}/${path}`;
    }
    return url;
});

onMounted(() => {
    service_engine_fun_list();
});

// MARK Service 获取功能介绍列表
const service_engine_fun_list = () => {
    proxy.$showLoading();
    getEngineFunctionList().then((res) => {
        proxy.$hideLoading();
        if (res.isSuccess) {
            function_list.value = res.data;
        }
    });
};

// MARK Grid 点击事件
const func_grid_item_click = (item) => {
    router_store.navigateToFuncDetail({ id: item.id });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-func-list {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 100px;

    .top-box {
        position: relative;
        margin-top: 48px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .top-title {
            position: relative;
            height: 60px;
            font-weight: 400;
            font-size: 40px;
            color: var(--color-main-text-primary);
        }

        .dis-box {
            position: relative;
            margin-top: 20px;
            width: 100%;
            height: 37px;
            display: flex;
            justify-content: center;
            align-items: center;

            .top-dis {
                position: relative;
                height: 100%;
                font-weight: 400;
                font-size: 20px;
                color: var(--color-main-text-secondary);
                line-height: 37px;
            }
        }
    }

    .grid-list-box {
        position: relative;
        margin-top: 56px;
        width: 100%;
        flex-shrink: 0;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 60px;
        row-gap: 40px;

        .grid-item-box {
            position: relative;
            display: flex;
            width: 360px;
            height: 240px;
            align-items: center;
            border-radius: 7px;
            cursor: pointer;
            overflow: hidden;
            flex-direction: column;
            background-color: var(--color-main-light-bg-white);
            box-shadow: var(--color-main-card-shadow-big);

            .grid-item-img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
            }

            .gird-item-title-box {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 53px;
                display: flex;
                align-items: center;
                padding: 0 17px;
                box-sizing: border-box;
                backdrop-filter: var(--color-main-backdrop-filte);
                background: var(--color-main-product-backdrop-filter-background);

                span {
                    position: relative;
                    font-weight: 400;
                    font-size: 20px;
                    color: var(--color-main-text-dark-bg-primary);
                }
            }
        }

        &::-webkit-scrollbar {
            display: none;
        }
    }
}
</style>
